import React from 'react';

import { Box } from '@mui/material';

const Then = ({ conditional, children }) =>
	conditional && <Box>{children}</Box>;

export default Then;
